import React from 'react';
import PropTypes from 'prop-types';
import { Row, Columns } from 'views/Grid';
import SellerInfo from './SellerInfo';
import CartDropdown from 'views/CartDropdown';

const Header = ({ isCartEnabled, onShowCart }) => {
  return (
    <header className="header">
      <Row>
        <Columns className="small-12">
          <div className="flex-space-between" style={{ height: '58px' }}>
            <div>
              <SellerInfo
                refTag="offer_header"
              />
            </div>
            <div>
            { isCartEnabled ?
              <CartDropdown
                onClick={() => onShowCart()}
              /> :
              null
            }
            </div>
          </div>
        </Columns>
      </Row>
    </header>
  );
};

export default Header;

Header.propTypes = {
  isCartEnabled: PropTypes.bool.isRequired,
  onShowCart: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/product/views/_layout/Header.js